import { PhoneFrame } from "../components/PhoneFrame";
import { StoreButtons } from "../components/StoreButtons";
import { SCREENS } from "../data/screens";
import { RichText, useSiteTranslation } from "../i18n";
import logo from "../../../pictures/home/logo-m.png";
import floralWide from "../../../pictures/home/floral-wide.png";
import "../styles/download.css";

export function DownloadSection() {
  const { t } = useSiteTranslation();

  return (
    <section className="download">
      <div className="wrap download-card" data-reveal>
        <img className="download-floral" src={floralWide} alt="" aria-hidden="true" />
        <div className="download-copy">
          <img className="download-logo" src={logo} alt="MJMarry" />
          <p className="eyebrow">{t("home.download.eyebrow")}</p>
          <h2>
            <RichText k="home.download.title" />
          </h2>
          <p>{t("home.download.text")}</p>
          <p className="download-note">{t("home.download.note")}</p>
          <StoreButtons className="download-store-row" />
        </div>
        <PhoneFrame className="download-phone" src={SCREENS.chats.src} alt={t(SCREENS.chats.alt)} />
      </div>
    </section>
  );
}
